import { loc } from "../i18n/survey";

enum NumberWorkouts {
  Two = "2",
  Three = "3",
  Four = "4",
  Five = "5",
  AsManyAsPossible = "As many as possible",
}

const numberWorkoutsQuestion = {
  name: "numberWorkouts",
  title: loc("quiz.numberWorkouts.title"),
  description: loc("quiz.numberWorkouts.description"),
  descriptionLocation: "underTitle",
  type: "radiogroup",
  choices: [
    {
      value: NumberWorkouts.Two,
      text: loc("quiz.numberWorkouts.choices.two"),
      visibleIf: "{availableDays.length} >= 2",
    },
    {
      value: NumberWorkouts.Three,
      text: loc("quiz.numberWorkouts.choices.three"),
      visibleIf: "{availableDays.length} >= 3",
    },
    {
      value: NumberWorkouts.Four,
      text: loc("quiz.numberWorkouts.choices.four"),
      visibleIf: "{availableDays.length} >= 4",
    },
    {
      value: NumberWorkouts.Five,
      text: loc("quiz.numberWorkouts.choices.five"),
      visibleIf: "{availableDays.length} >= 5",
    },
    {
      value: NumberWorkouts.AsManyAsPossible,
      text: loc("quiz.numberWorkouts.choices.six"),
      visibleIf: "{availableDays.length} >= 6",
      enableIf: "{experience} != 'Beginner'",
    },
  ],
  isRequired: true,
};

export { NumberWorkouts, numberWorkoutsQuestion };
